import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const importStripeInfo = {
  name: "importStripeInfo" as const,
  input: z.object({
    teamId: zExt.objectId(),
    stripeCustomerId: z.string().min(1),
  }),
  output: z.object({ success: z.boolean(), error: z.string().nullable() }),
};
